import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { secondlogo } from "../../Constant/Index";
import { useDispatch } from "react-redux";
import ReUse from "../../services/helpers/reUse";
import AppService from "../../services/appServices";
import { toast } from "react-toastify";
import { AuthActions } from "../../redux/slices/auth.slice";
import {
	clearResponseMessageAfterDelay,
	errorMessage,
	successMessage,
} from "../../redux/slices/responseMessage.slice";
import ResponseMessage from "../../Components/ReUse/ResponseMessage";
import CustomButton from "../../Components/ReUse/Components/Button";
import FieldError from "../../Components/ReUse/FieldError";

function Enteremail() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	const [allErrors, setAllErrors] = useState({
		email: "",
	});

	const [fieldsData, setFieldsData] = useState({
		email: "",
	});

	function handleChange(e) {
		const resetErrors = ReUse.resetErrors({ fields: allErrors });
		setAllErrors(resetErrors);
		const { value, name } = e.target;
		setFieldsData({
			...fieldsData,
			[name]: value,
		});
	}

	const onSubmitHandler = async (e) => {
		e.preventDefault();

		try {
			setLoading(true);

			const { email } = fieldsData;

			const fields = {
				email,
			};
			const allErrors = ReUse.validateRequired({ fields: fields });

			// Check if there are any errors
			if (Object.keys(allErrors).length > 0) {
				setAllErrors(allErrors);
				setLoading(false);
				return;
			}

			const payLoad = {
				email,
			};

			const apiResp = await AppService.customerForgotPassword(payLoad);
			const { message, response } = apiResp.data;
			setLoading(false);
			dispatch(successMessage(message));
			setTimeout(() => {
				dispatch(successMessage("Navigating..."));
				setTimeout(() => {
					dispatch(successMessage(""));
					navigate("/enter-otp", { state: { email: email } });
				}, 1000);
			}, 1000);

			ReUse.resetErrors({ fields: allErrors }); // allErrors is an object
			ReUse.resetForm({ fields: fieldsData }); // fieldsData is an object
		} catch (err) {
			setLoading(false);
			dispatch(errorMessage(err?.response?.data?.message));
			dispatch(clearResponseMessageAfterDelay());
			ReUse.resetErrors({ fields: allErrors }); // allErrors is an object
			ReUse.resetForm({ fields: fieldsData }); // fieldsData is an object
			dispatch(successMessage(""));
		}
	};

	return (
		<>
			{/* Enter Email Section */}
			<section className="login-sec sign-in-sec enter-email-sec">
				<div className="container">
					<div className="row">
						<div className="login-page-logo">
							<Link to="/">
								<figure>
									<img
										className="img-fluid"
										alt="login-page-logo"
										src={secondlogo}
									/>
								</figure>
							</Link>
						</div>
						<div className="col-md-6">
							<div className="div-for-all-movement">
								<div className="enter-email-movement">
									<div className="welcome-back-sec">
										<h3>Welcome Back!</h3>
										<p>
											Lorem ipsum dolor sit amet, consectetur adipiscing elit.
											Fusce laoreet mauris sit amet venenatis cursus. Fusce quis
											libero orci. Donec posuere lacus id felis hendrerit
											dapibus. Mauris
										</p>
										<div className="login-signin-btn">
											<Link to="/sign-in">Sign in</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="login-form">
								<form>
									<div className="row">
										<div className="form-head">
											<h3>Enter Your Email</h3>
											<p>Please Enter Your Email Below</p>
										</div>
										<div className="col-md-12">
											<div className="form-login-input">
												<input
													type="text"
													placeholder="Email"
													onChange={handleChange}
													name="email"
													value={fieldsData?.email}
												/>

												<FieldError fieldName={allErrors?.email} />
											</div>
										</div>
										<div className="col-md-12">
											<div className="enter-email-para">
												{/* <p>
													An Email Has Been Sent To Reset The Password Haven't
													Received The Email Yet? Try Again
												</p> */}
											</div>
										</div>

										<div className="login-signup-btn">
											<a>
												<CustomButton
													loading={loading}
													onClickHandler={onSubmitHandler}
													customClassName="btn"
												>
													Submit
												</CustomButton>
											</a>
											<ResponseMessage />
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* ================ */}
		</>
	);
}

export default Enteremail;
